module.exports = __webpack_public_path__ + "img/finalLSmv.6ea79f7c.png";